import { render, staticRenderFns } from "./GraduatesWork.vue?vue&type=template&id=01a08ad4&"
import script from "./GraduatesWork.vue?vue&type=script&lang=js&"
export * from "./GraduatesWork.vue?vue&type=script&lang=js&"
import style0 from "./GraduatesWork.vue?vue&type=style&index=0&id=01a08ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports